export default "__VITE_ASSET__j2GNUSgO__"